var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPixelArtSkytower(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 768,
    viewBox: "0 0 298 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 736,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 736,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 736,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 544,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 544,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 640,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 640,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 448,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 448,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 704,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 704,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 512,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 512,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 608,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 608,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 416,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 416,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 672,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 672,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 480,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 480,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 576,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 640,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 613,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 613,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 640,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 672,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 704,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 736,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 672,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 704,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 736,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 576,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 384,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 384,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 384,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 352,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 320,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 288,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    y: 288,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 288,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 288,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 288,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 288,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 288,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 288,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 288,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 288,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 288,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 288,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 384,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 352,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 320,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 192,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 160,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 160,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 160,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 192,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 160,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 128,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 96,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 64,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 32,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 133,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 256,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 224,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 224,
    width: 32,
    height: 32,
    fill: "#BECEE5"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 256,
    width: 32,
    height: 32,
    fill: "#BECEE5"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 256,
    width: 32,
    height: 32,
    fill: "#BECEE5"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 320,
    width: 32,
    height: 32,
    fill: "#BECEE5"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 352,
    width: 32,
    height: 32,
    fill: "#BECEE5"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 224,
    width: 32,
    height: 32,
    fill: "#BECEE5"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 224,
    width: 32,
    height: 32,
    fill: "#BECEE5"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 192,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 160,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 160,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 160,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 256,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 224,
    width: 32,
    height: 32,
    fill: "#323AF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixelArtSkytower);
export default __webpack_public_path__ + "static/media/pixel-art-skytower.f5a3f3d4e719815a95835337d4ed2a58.svg";
export { ForwardRef as ReactComponent };